import { isAxiosError } from 'axios'
import { apiClient } from '@/api/http/client'
import { ApiError } from '@/api/http/types'
import type { ApiResponse } from '@/api/http/types'

const WIZARD_AI_READINESS_TIMEOUT_MS = 10_000

const STALE_CAMPAIGN_SERVICE_MSG =
  'Campaign service needs a restart. Run `pnpm dev` in brushfire-campaign-service, then retry.'

function rethrowReadinessFailure(e: unknown): never {
  if (e instanceof ApiError && e.status === 404) {
    throw new ApiError(STALE_CAMPAIGN_SERVICE_MSG, 503, 'service_unavailable')
  }
  if (isAxiosError(e) && e.response?.status === 404) {
    throw new ApiError(STALE_CAMPAIGN_SERVICE_MSG, 503, 'service_unavailable')
  }
  throw e
}

/** Fast preflight before step 1/2 AI — fails in seconds when brushfire-ai-service is down. */
export async function checkWizardAiReadiness(signal?: AbortSignal): Promise<void> {
  try {
    await apiClient.get<ApiResponse<{ ready: boolean }>>(
      '/api/v1/campaigns/wizard/ai-readiness',
      { signal, timeout: WIZARD_AI_READINESS_TIMEOUT_MS },
    )
  } catch (e) {
    rethrowReadinessFailure(e)
  }
}
